module.exports = __webpack_public_path__ + "img/generally_green.9f4adb71.png";